import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { ROLE_LABEL } from "../../lib/api";
import { ACTIONS } from "./AuditFilters";

const COLORS = {
  create: "bg-emerald-600 text-white",
  update: "bg-primary text-primary-foreground",
  delete: "bg-rose-600 text-white",
  import: "bg-violet-700 text-white",
  renew: "bg-amber-500 text-white",
};

const Changes = ({ log }) => (
  <div className="mt-3 border bg-muted/30 overflow-x-auto" data-testid={`audit-changes-${log.log_id}`}>
    <table className="w-full text-xs">
      <thead>
        <tr className="text-left border-b">
          <th className="px-3 py-2 eyebrow">Kolom</th>
          <th className="px-3 py-2 eyebrow">{log.action === "delete" ? "Nilai Terhapus" : "Sebelum"}</th>
          {log.action !== "delete" && <th className="px-3 py-2 eyebrow">Sesudah</th>}
        </tr>
      </thead>
      <tbody>
        {log.changes.map((c) => (
          <tr key={c.field} className="border-b last:border-0 align-top">
            <td className="px-3 py-2 font-medium whitespace-nowrap">{c.label}</td>
            <td className="px-3 py-2 whitespace-pre-line text-rose-700 line-through decoration-rose-300">{c.before || "-"}</td>
            {log.action !== "delete" && <td className="px-3 py-2 whitespace-pre-line text-emerald-700">{c.after || "-"}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const AuditRow = ({ log }) => {
  const [open, setOpen] = useState(false);
  const has = log.changes?.length > 0;
  return (
    <div className="px-5 py-3.5" data-testid={`audit-row-${log.log_id}`}>
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
        <div className="md:w-40 shrink-0 font-mono text-xs text-muted-foreground">{new Date(log.at).toLocaleString("id-ID")}</div>
        <span className={`self-start md:self-auto px-2 py-0.5 text-[11px] font-semibold uppercase rounded-sm whitespace-nowrap ${COLORS[log.action]}`}>{ACTIONS[log.action]}</span>
        <div className="flex-1 min-w-0 text-sm">
          <span className="font-medium">{log.category_label}</span>
          {log.polda && <span className="text-muted-foreground"> &middot; {log.polda}</span>}
          <span className="text-muted-foreground"> &mdash; </span>
          <span className="break-words">{log.summary}</span>
        </div>
        <div className="md:text-right text-xs leading-tight shrink-0">
          <div className="font-medium">{log.user_name || log.user_email}</div>
          <div className="text-muted-foreground">{ROLE_LABEL[log.user_role]}{log.user_polda ? ` · ${log.user_polda}` : ""}</div>
        </div>
        {has ? (
          <button onClick={() => setOpen(!open)} className="self-start md:self-auto p-1 hover:bg-muted transition-colors" data-testid={`audit-toggle-${log.log_id}`} title="Lihat detail">
            <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        ) : <span className="hidden md:block w-6" />}
      </div>
      {open && has && <Changes log={log} />}
    </div>
  );
};
